import React from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import Tab from '../../../common/tab-timer';
import Footer from '../../../common/table/Footer';
import CurrentState from '../../../helpers/CurrentState';
import Abnormality from './abnormality/Abnormality';
import Aggressive from './aggressive/Aggressive';
import Cancelled from './cancelled/Cancelled';
import Closing from './closing/Closing';
import DropDownWatchList from './DropDownWatchList';
import Overview from './overview/Overview';
import Pressing from './pressing/Pressing';
import CommonConst from '../../../common/Const';
import {
  fetchMyWatchList,
  changeTabData,
  REDUCER_NAME,
  setFilterData,
} from './reducer';
import SearchBox from './SearchBox';

class Deceptive extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      renderKey: 0,
    };
    const { subTab } = this.props;
    if (subTab) {
      props.changeTabData(subTab);
    }
  }

  componentDidMount() {
    const { setFilterData } = this.props;
    const prevFilterData = CurrentState.get(
      CommonConst.listComponent.TASignals,
      'filterData',
    );
    if (prevFilterData) {
      setFilterData(prevFilterData);
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { filterData } = this.props;
    if (filterData !== prevProps.filterData) {
      CurrentState.add(
        CommonConst.listComponent.TASignals,
        'filterData',
        filterData,
      );
    }
  }

  componentWillUnmount() {
    clearInterval(this.intervalId);
  }

  changeTab = currentTab => {
    const { changeTabData } = this.props;

    changeTabData(currentTab);
  };

  render() {
    const { renderKey } = this.state;
    const { currentTabData, filterData, watchLists } = this.props;
    const isFetchedWatchlist = watchLists && watchLists.length;

    return (
      <div
        key={renderKey}
        className="tab-pane active deceptive-wrapper d-flex flex-fill flex-column"
      >
        <div className="list-filter flex-shrink-0">
          <Tab
            tooltips={[
              '',
              I18n.t('tasignals.abnormalityContent.tooltipContent'),
              I18n.t('tasignals.cancelledContent.tooltipContent'),
              I18n.t('tasignals.pressingContent.tooltipContent'),
              I18n.t('tasignals.aggressiveContent.tooltipContent'),
              I18n.t('tasignals.closingContent.tooltipContent'),
            ]}
            currentTab={currentTabData}
            listTab="tasignals.deceptiveTab"
            changeTab={this.changeTab}
          />
        </div>
        <div className="custome-tabs-deceptive d-flex flex-fill flex-column">
          <div className="deceptive-dropdown mb-10 flex-shrink-0">
            <SearchBox />
            <DropDownWatchList isOverview={currentTabData === 1} />
          </div>
          {currentTabData === 1 && isFetchedWatchlist && (
            <Overview filter={filterData[currentTabData]} />
          )}
          {currentTabData === 2 && isFetchedWatchlist && (
            <Abnormality filter={filterData[currentTabData]} />
          )}
          {currentTabData === 3 && isFetchedWatchlist && (
            <Cancelled filter={filterData[currentTabData]} />
          )}
          {currentTabData === 4 && isFetchedWatchlist && (
            <Pressing filter={filterData[currentTabData]} />
          )}
          {currentTabData === 5 && isFetchedWatchlist && (
            <Aggressive filter={filterData[currentTabData]} />
          )}
          {currentTabData === 6 && isFetchedWatchlist && (
            <Closing filter={filterData[currentTabData]} />
          )}

          <Footer
            listTextLang={[
              {
                text: 'common.table.TABLE_FOOTER_TEXT_WITH_UNIT',
                style: {},
              },
            ]}
          />
        </div>
      </div>
    );
  }
}
const mapStateToProps = state => {
  return {
    i18n: state.i18n,
    currentTabData: state[REDUCER_NAME].currentTabData,
    filterData: state[REDUCER_NAME].filterData,
    listWatchListByWatchListId: state[REDUCER_NAME].listWatchListByWatchListId,
    watchLists: state[REDUCER_NAME].watchLists,
  };
};

const mapDispatchToProps = {
  fetchMyWatchList,
  changeTabData,
  setFilterData,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Deceptive);
